import React from "react";
import type { FC } from "react";
import UtilityPanel from "../layout/UtilityPanel";
import CoreLayout from "../layout/CoreLayout";
import { IconCaution } from "../icons";
import Button from "../form/Button";
import { useAppStore } from "../../store/appStore";
import { withErrorBoundary } from "../components/withErrorBoundary";

interface Props {
    cancelSession: () => void;
}

const MfaCodeUserLockedError: FC<Props> = (props) => {
    const { setSessionStatus } = useAppStore();

    function onNext() {
        props.cancelSession();
        setSessionStatus("CANCELLED");
    }

    const header = (
        <div className="self-stretch inline-flex justify-start items-center gap-3">
            <IconCaution />
            <div className="flex-1 justify-start font-normal font-['Inter']">
                <div className="text-king-red text-base">
                    Your PGE Account is Temporarily Locked for One Hour
                </div>
                <div className="text-king-red text-xs font-normal">
                    You have entered an incorrect one-time PG&E authentication code too many times.
                </div>
            </div>
        </div>
    );

    return (
        <CoreLayout>
            <UtilityPanel headerOverride={header}>
                <div className="flex flex-col gap-4">
                    <div className="text-black text-xs font-normal font-['Inter']">
                        You will not be able to access your PG&E account for one hour.
                        <br /> <br />
                        Please try again in one hour.
                    </div>

                    <div className="w-full flex justify-end">
                        <Button onClick={onNext} type="primary">
                            Back to Login Step
                        </Button>
                    </div>
                </div>
            </UtilityPanel>
        </CoreLayout>
    );
};

export default withErrorBoundary(MfaCodeUserLockedError);
